// This file is auto-generated by the generate:translations task. Do not edit directly.

enum GeneralKeys {
  Add = 'general:add',
  SaveData = 'general:saveData',
  Generic = 'general:generic',
  Select = 'general:select',
  Remove = 'general:remove',
  Edit = 'general:edit',
  Yes = 'general:yes',
  No = 'general:no',
  Next = 'general:next',
  Back = 'general:back',
  Understood = 'general:understood',
  Confirm = 'general:confirm',
  NotNow = 'general:notNow',
  MediPlus = 'general:mediPlus',
  Option = 'general:option',
  Or = 'general:or',
  The = 'general:the',
  ErrorTryAgain = 'general:errorTryAgain',
  Notifications_ChangesSaved = 'general:notifications.changesSaved',
  SortDateAsc = 'general:sortDateAsc',
  SortDateDesc = 'general:sortDateDesc',
  SortTitleAsc = 'general:sortTitleAsc',
  SortTitleDesc = 'general:sortTitleDesc',
  OriginalMedicament = 'general:originalMedicament',
  OriginalMedicaments = 'general:originalMedicaments',
  Status = 'general:status',
  Telephone = 'general:telephone',
  GoToSettings = 'general:goToSettings',
  GoToDashboard = 'general:goToDashboard',
  GenericError = 'general:genericError',
  HealthInfo = 'general:healthInfo',
  ChangeInfo = 'general:changeInfo',
  LastChecked = 'general:lastChecked',
  Congratulation = 'general:congratulation',
  Notifications_NewEmailLoginHint = 'general:notifications.newEmail_loginHint',
  Notifications_NewEmailSuccess = 'general:notifications.newEmail_success',
  Notifications_RegisterConfirmationSuccess = 'general:notifications.registerConfirmation_success',
  Notifications_ErrorConfirmTermsAndPrivacy = 'general:notifications.errorConfirmTermsAndPrivacy',
  Notifications_RegisterConfirmationTokenExpired = 'general:notifications.registerConfirmation_tokenExpired',
  Notifications_AccountActivated = 'general:notifications.accountActivated',
  Notifications_DeactivateSuccessMedidossier = 'general:notifications.deactivate_successMedidossier',
  Notifications_PermissionDeniedHeadline = 'general:notifications.permissionDeniedHeadline',
  Notifications_PermissionDeniedText = 'general:notifications.permissionDeniedText',
  Notifications_AutomaticLogout = 'general:notifications.automaticLogout',
  Notifications_PublicPrices = 'general:notifications.publicPrices',
  Notifications_SessionInvalidText = 'general:notifications.sessionInvalidText',
  ReloadPage = 'general:reloadPage',
  AddressType_DeliveryAddress = 'general:addressType.deliveryAddress',
  AddressType_DomicilAddress = 'general:addressType.domicilAddress',
  GenericMedicamentSubstitutionAllowedHint = 'general:genericMedicamentSubstitutionAllowedHint',
  ConfirmTermsAndPrivacy = 'general:confirmTermsAndPrivacy',
  BtnAcceptAGB = 'general:btnAcceptAGB',
  ConfirmAGB = 'general:confirmAGB',
  Notifications_ErrorConfirmAGB = 'general:notifications.errorConfirmAGB',
  NewsletterOverlayContent = 'general:newsletterOverlayContent',
  NewsletterBenefit1 = 'general:newsletterBenefit1',
  NewsletterBenefit2 = 'general:newsletterBenefit2',
  NewsletterBenefit3 = 'general:newsletterBenefit3',
  NewsletterBenefit4 = 'general:newsletterBenefit4',
  NewsletterOverlayChoose = 'general:newsletterOverlayChoose',
  NewsletterOverlayFootnote = 'general:newsletterOverlayFootnote',
  Cancel = 'general:cancel',
  BackToDashboard = 'general:backToDashboard',
  BackToOverview = 'general:backToOverview',
  ZurroseEmail = 'general:zurroseEmail',
  Close = 'general:close',
  None = 'general:none',
  ConfirmAndSave = 'general:confirmAndSave',
  Weight = 'general:weight',
  Size = 'general:size',
  DateOfBirth = 'general:dateOfBirth',
  SetUp = 'general:setUp',
  Help = 'general:help',
  Username = 'general:username',
  Change = 'general:change',
  Salutation_1 = 'general:salutation.1',
  Salutation_2 = 'general:salutation.2',
  Title_1 = 'general:title.1',
  Title_2 = 'general:title.2',
  Title_3 = 'general:title.3',
  Title_4 = 'general:title.4',
  Title_5 = 'general:title.5',
  Title_6 = 'general:title.6',
  Reset = 'general:reset',
  Expired = 'general:expired',
  Exhausted = 'general:exhausted',
  Notifications_NewEmailTokenExpired = 'general:notifications.newEmail_tokenExpired',
  Notifications_NewEmailTokenRedeemed = 'general:notifications.newEmail_tokenRedeemed',
  CustomerId = 'general:customerId',
  NoFilterMatches = 'general:noFilterMatches',
  NoNewMessages = 'general:noNewMessages',
  GeneralContactText = 'general:generalContactText',
  GotToProfile = 'general:gotToProfile',
  Ok = 'general:ok',
  DontShowAgain = 'general:dontShowAgain',
  Info = 'general:info',
  ConfirmAndContinue = 'general:confirmAndContinue',
  SaveAndContinue = 'general:saveAndContinue',
  Storno = 'general:storno',
  Delivery = 'general:delivery',
  Box = 'general:box',
  Boxes = 'general:boxes',
  GetsOrderedAt = 'general:getsOrderedAt',
  DeliveryToHomeAddress = 'general:deliveryToHomeAddress',
  DeliveryToDeliveryAddress = 'general:deliveryToDeliveryAddress',
  ShippingLabel = 'general:shippingLabel',
  ValidUntil = 'general:validUntil',
  Remaining = 'general:remaining',
  AsNeeded = 'general:asNeeded',
  Dosage = 'general:dosage',
  PdfGenerationPleaseWait = 'general:PdfGenerationPleaseWait',
  Notifications_ExpiresSoonWithDetails = 'general:notifications.expiresSoonWithDetails',
  Notifications_CoolingMedicine = 'general:notifications.coolingMedicine',
  Notifications_ExpiresSoon = 'general:notifications.expiresSoon',
  Notifications_TooltipExpiresSoon = 'general:notifications.tooltipExpiresSoon',
  MedicationsWithSelectableDeliverySlot = 'general:medicationsWithSelectableDeliverySlot',
  SelectableDeliverySlotConditions = 'general:selectableDeliverySlotConditions',
  RecipeInfo = 'general:recipeInfo',
  Doctor = 'general:doctor',
  Of = 'general:of',
  SelectADate = 'general:selectADate',
  DaysString_1 = 'general:daysString.1',
  DaysString_2 = 'general:daysString.2',
  SavePersonalData = 'general:savePersonalData',
  DontsaveData = 'general:dontsaveData',
  PickPostOpeningHours24h = 'general:pickPostOpeningHours24h',
  ShortDay_Monday = 'general:shortDay.monday',
  ShortDay_Tuesday = 'general:shortDay.tuesday',
  ShortDay_Wednesday = 'general:shortDay.wednesday',
  ShortDay_Thursday = 'general:shortDay.thursday',
  ShortDay_Friday = 'general:shortDay.friday',
  ShortDay_Saturday = 'general:shortDay.saturday',
  ShortDay_Sunday = 'general:shortDay.sunday',
  OClock = 'general:oClock',
  ViewOpeningTimes = 'general:viewOpeningTimes',
  CompleteData = 'general:completeData',
  Notifications_MergeCustomerText = 'general:notifications.mergeCustomerText',
  Notifications_MergeCustomerYes = 'general:notifications.mergeCustomerYes',
  Notifications_MergeCustomerNo = 'general:notifications.mergeCustomerNo',
  Wegovy_Title = 'general:wegovy.title',
  Substitution = 'general:substitution',
  GoToOrder = 'general:goToOrder',
  Revert = 'general:revert',
  Reverted = 'general:reverted',
  Now = 'general:now',
  HideDetails = 'general:hideDetails',
  StatusActive = 'general:statusActive',
  StatusInactive = 'general:statusInactive',
  PageTitleWelcomePage = 'general:pageTitleWelcomePage',
  PageTitleWelcomePageMediplus = 'general:pageTitleWelcomePageMediplus',
  MetaTags_Description_LoginPage = 'general:metaTags.description.loginPage',
  MetaTags_Description_Welcome = 'general:metaTags.description.welcome',
  Notification_ShowMore = 'general:notification.showMore',
}
type GeneralKey =
  | 'add'
  | 'saveData'
  | 'generic'
  | 'select'
  | 'remove'
  | 'edit'
  | 'yes'
  | 'no'
  | 'next'
  | 'back'
  | 'understood'
  | 'confirm'
  | 'notNow'
  | 'mediPlus'
  | 'option'
  | 'or'
  | 'the'
  | 'errorTryAgain'
  | 'notifications.changesSaved'
  | 'sortDateAsc'
  | 'sortDateDesc'
  | 'sortTitleAsc'
  | 'sortTitleDesc'
  | 'originalMedicament'
  | 'originalMedicaments'
  | 'status'
  | 'telephone'
  | 'goToSettings'
  | 'goToDashboard'
  | 'genericError'
  | 'healthInfo'
  | 'changeInfo'
  | 'lastChecked'
  | 'congratulation'
  | 'notifications.newEmail_loginHint'
  | 'notifications.newEmail_success'
  | 'notifications.registerConfirmation_success'
  | 'notifications.errorConfirmTermsAndPrivacy'
  | 'notifications.registerConfirmation_tokenExpired'
  | 'notifications.accountActivated'
  | 'notifications.deactivate_successMedidossier'
  | 'notifications.permissionDeniedHeadline'
  | 'notifications.permissionDeniedText'
  | 'notifications.automaticLogout'
  | 'notifications.publicPrices'
  | 'notifications.sessionInvalidText'
  | 'reloadPage'
  | 'addressType.deliveryAddress'
  | 'addressType.domicilAddress'
  | 'genericMedicamentSubstitutionAllowedHint'
  | 'confirmTermsAndPrivacy'
  | 'btnAcceptAGB'
  | 'confirmAGB'
  | 'notifications.errorConfirmAGB'
  | 'newsletterOverlayContent'
  | 'newsletterBenefit1'
  | 'newsletterBenefit2'
  | 'newsletterBenefit3'
  | 'newsletterBenefit4'
  | 'newsletterOverlayChoose'
  | 'newsletterOverlayFootnote'
  | 'cancel'
  | 'backToDashboard'
  | 'backToOverview'
  | 'zurroseEmail'
  | 'close'
  | 'none'
  | 'confirmAndSave'
  | 'weight'
  | 'size'
  | 'dateOfBirth'
  | 'setUp'
  | 'help'
  | 'username'
  | 'change'
  | 'salutation.1'
  | 'salutation.2'
  | 'title.1'
  | 'title.2'
  | 'title.3'
  | 'title.4'
  | 'title.5'
  | 'title.6'
  | 'reset'
  | 'expired'
  | 'exhausted'
  | 'notifications.newEmail_tokenExpired'
  | 'notifications.newEmail_tokenRedeemed'
  | 'customerId'
  | 'noFilterMatches'
  | 'noNewMessages'
  | 'generalContactText'
  | 'gotToProfile'
  | 'ok'
  | 'dontShowAgain'
  | 'info'
  | 'confirmAndContinue'
  | 'saveAndContinue'
  | 'storno'
  | 'delivery'
  | 'box'
  | 'boxes'
  | 'getsOrderedAt'
  | 'deliveryToHomeAddress'
  | 'deliveryToDeliveryAddress'
  | 'shippingLabel'
  | 'validUntil'
  | 'remaining'
  | 'asNeeded'
  | 'dosage'
  | 'PdfGenerationPleaseWait'
  | 'notifications.expiresSoonWithDetails'
  | 'notifications.coolingMedicine'
  | 'notifications.expiresSoon'
  | 'notifications.tooltipExpiresSoon'
  | 'medicationsWithSelectableDeliverySlot'
  | 'selectableDeliverySlotConditions'
  | 'recipeInfo'
  | 'doctor'
  | 'of'
  | 'selectADate'
  | 'daysString.1'
  | 'daysString.2'
  | 'savePersonalData'
  | 'dontsaveData'
  | 'pickPostOpeningHours24h'
  | 'shortDay.monday'
  | 'shortDay.tuesday'
  | 'shortDay.wednesday'
  | 'shortDay.thursday'
  | 'shortDay.friday'
  | 'shortDay.saturday'
  | 'shortDay.sunday'
  | 'oClock'
  | 'viewOpeningTimes'
  | 'completeData'
  | 'notifications.mergeCustomerText'
  | 'notifications.mergeCustomerYes'
  | 'notifications.mergeCustomerNo'
  | 'wegovy.title'
  | 'substitution'
  | 'goToOrder'
  | 'revert'
  | 'reverted'
  | 'now'
  | 'hideDetails'
  | 'statusActive'
  | 'statusInactive'
  | 'pageTitleWelcomePage'
  | 'pageTitleWelcomePageMediplus'
  | 'metaTags.description.loginPage'
  | 'metaTags.description.welcome'
  | 'notification.showMore';

export { GeneralKeys, type GeneralKey };
